var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banners.length)?_c('div',{directives:[{name:"rotate-backgrounds",rawName:"v-rotate-backgrounds",value:(_vm.banners),expression:"banners"}],key:_vm.forceUpdate,staticClass:"rotate-backgrounds"},[_c('div',{staticClass:"overlay-fade"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }